
import {
  defineComponent,
  ref,
  computed,
  type PropType,
} from 'vue';
import { Method } from './method';
import {
  anchorKinds,
  uppercaseKinds,
} from '@/heplers';


export default defineComponent({
  name: 'Parse',
  components: {
    Method,
  },
  props: {
    data: {
      type: Array as PropType<unknown[]>,
      default: () => [],
    },
    name: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const currentRole = ref('All Roles');

    const parseData = computed(() => props.data ?? []);
    const checkAnchorKinds = computed(() => anchorKinds.includes(props.name));
    const capitalizeName = computed(
      () => (uppercaseKinds as Record<string, string>)[props.name] ?? props.name
    );

    return {
      parseData,
      checkAnchorKinds,
      capitalizeName,
      currentRole,
    };
  },
});
